import axios from 'axios';

import { AwsS3UploadParameters } from '@uppy/aws-s3';

import { API_URL } from '../core/config';

export const FILE_UPLOADS_URL = `${API_URL}/file_uploads.json`;

export function getPresignedUrl(modelName: string, propertyName: string): Promise<AwsS3UploadParameters> {
  return new Promise((resolve, reject) => {
    axios
      .get(FILE_UPLOADS_URL, {
        params: { model_name: modelName, property_name: propertyName },
      })
      .then(({ data }) => {
        if (data) {
          resolve({
            method: 'POST',
            url: data.upload_url,
            fields: data.upload_url_payload,
          });
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}
